export async function clearAppCaches({ clearCookies = false, knownDbNames = [] } = {}) {
  if (typeof window === 'undefined') return

  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map(r => r.unregister()))
    }
  } catch {}

  try {
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map(k => caches.delete(k)))
    }
  } catch {}

  // 3) Storages
  try {
    localStorage.clear()
  } catch {}
  try {
    sessionStorage.clear()
  } catch {}

  // 4) IndexedDB
  try {
    if (window.indexedDB) {
      // Soportado en Chrome/Edge/Firefox modernos
      if (indexedDB.databases) {
        const dbs = await indexedDB.databases()
        await Promise.all(
          (dbs || []).map(db =>
            db?.name
              ? new Promise(res => {
                  const req = indexedDB.deleteDatabase(db.name)
                  req.onsuccess = req.onerror = req.onblocked = () => res()
                })
              : Promise.resolve()
          )
        )
      } else if (knownDbNames.length) {
        // Fallback (Safari iOS, etc.)
        await Promise.all(
          knownDbNames.map(
            name =>
              new Promise(res => {
                const req = indexedDB.deleteDatabase(name)
                req.onsuccess = req.onerror = req.onblocked = () => res()
              })
          )
        )
      }
    }
  } catch {}

  // 5) (Opcional) Cookies accesibles por JS (no borra HttpOnly/otro dominio)
  if (clearCookies) {
    try {
      document.cookie.split(';').forEach(c => {
        const name = c.split('=')[0]?.trim()
        if (name) {
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
        }
      })
    } catch {}
  }
}
